import Input from './Input.component';

export default Input;
